import React, { useState, useEffect, useRef } from "react";
import "./MedicalKit.css";
import { Box, DataTable, TextInput, Text, Layer } from "grommet";
import CommonButton from "../../../common/Button/CommonButton";
import searchIcon from "../../../../../../assets/search.svg";
import filtericon from "../../../../../../assets/filter_icon.svg";
import editsquare from "../../../../../../assets/edit_square.svg";
import MedicalKitService from "../../../../../../services/medical-kit/medical-kit.service";
import { useStore } from "../../../../../../Hooks/useStore";
import { format } from "date-fns";
import QR from "../../../../../../assets/qr_code_scanner.svg";
import CreateKitSidebar from "./CreateKitSidebar";
import QR2 from "../../../../../../assets/qr.png";
import closeCross from "../../../../../../assets/close_qr.svg";
import QRDownload from "../../../../../../assets/cloud_download.svg";
import EditMedicalKit from "./EditMedicalKit";
import CommonSearchInput from "../../../common/SearchInput/CommonSearchInput";
import { observer } from "mobx-react";
import { QRCodeSVG } from 'qrcode.react';
import Pagination from "../../../common/Pagination/Pagination";
import Utility from "../../../../../../util/api/Utility";
import { useReactToPrint } from 'react-to-print';
import usersService from "../Users/users.service";
import noResult from "../../../../../../assets/no-result.png";
import smallclose_icon from "../../../../../../assets/close_small.svg";
import download from "../../../../../../assets/download-svgrepo-com.svg";
import view from "../../../../../../assets/veiw.svg";import { View } from "grommet-icons";
import { APIs } from "../../../../../../util/api/APIs.tsx";
import SafeairManager from "../../../../../../util/api/SafeairManager";
import { a } from "aws-amplify";
import ReassignMedicalKitSidebar from "./ReassignMedicalKitSidebar";
import reassignIcon from "../../../../../../assets/reassign.svg";

function MedicalKit() {
  const { rootStore } = useStore();
  const [originalList, setOriginalList] = useState([]);
  const [searchString, setSearchString] = useState("");
  const [sortedList, setSortedList] = useState([]);
  const [isCreateSidebarOpen, setIsCreateSidebarOpen] = useState(false);
  const [isEditSidebarOpen, setIsEditSidebarOpen] = useState(false);
  const [showFilterOptions, setShowFilterOptions] = useState(false);
  const [filterOption, setFilterOption] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [isQrPopupOpen, setIsQrPopupOpen] = useState({ isPopupShow: false, medicalKitId: null });
  const [selectedQrCode, setSelectedQrCode] = useState("");
  const [editKit, setEditKit] = useState(null);
  const [roleLabel,setRoleLabel] = useState("");
  const [isRoleLabelSet, setIsRoleLabelSet] = useState(false);
  const [modalData, setModalData] = useState([]);  
  const [isModalOpen, setModalOpen] = useState(false); 
  const [editingItemId, setEditingItemId] = useState(null);
  const [isReassignSidebarOpen, setIsReassignSidebarOpen] = useState(false);
  const [selectedKitForReassign, setSelectedKitForReassign] = useState(null);


// alert(JSON.stringify(modalData))
  // State to hold the selected kit for editing
  const contentRef = useRef(null);
  const reactToPrintFn = useReactToPrint({ contentRef });


  const qrRef = useRef(null);

  const filterDropdownRef = useRef(null); // Add ref for filter dropdown

  // Add useEffect for click-outside detection for filter dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (filterDropdownRef.current && !filterDropdownRef.current.contains(event.target)) {
        if (showFilterOptions) {
          setShowFilterOptions(false);
        }
      }
    };

    // Add event listener
    document.addEventListener('mousedown', handleClickOutside);
    
    // Cleanup
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showFilterOptions]);

  useEffect(() => {
    const setRoleLabelFromLocalStorage = async () => {
      let userInfo = localStorage.getItem("userinfo");
      const user = JSON.parse(userInfo)?.roleLabel.toLowerCase();
      setRoleLabel(user);
      setIsRoleLabelSet(true);
    };
    setRoleLabelFromLocalStorage();
  }, []);

  useEffect(() => {
    if (isRoleLabelSet) {
      getOrg();
    }
  }, [isRoleLabelSet,rootStore.medicalKitStore.getupdate]);

  const getOrg = async () => {
    try {
      let organizations = await usersService.listOrganizations();
      const org = organizations.filter(org => org.name === rootStore.adminStore.getSelectedOrgName)[0];
      if (roleLabel === "superadmin" || org.name.toLowerCase() === "skali") {
        getMedicalKit();
      } else {
        getMedicalKitById(org.id);
      }
    } catch (err) {
      console.log(err);
    }
  };


  const onViewClick = (passengerId) => {
    // navigate(`/passenger-details/${passengerId}`)
  }


  const openReassignSidebar = (kit) => {
    setSelectedKitForReassign(kit);
    setIsReassignSidebarOpen(true);
  };

  const closeReassignSidebar = () => {
    setIsReassignSidebarOpen(false);
    setSelectedKitForReassign(null);
  };



  const downloadSVG = (medicalKit) => {
    const svgElement = qrRef.current.querySelector('svg');
    const serializer = new XMLSerializer();
    const svgString = serializer.serializeToString(svgElement);
    const blob = new Blob([svgString], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = `qrcode_${medicalKit}.svg`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const getMedicalKitById = async (id) => {
    try {
      rootStore.loadingStore.setShowLoader(true);
      const MedicalData = await MedicalKitService.getMedicalKitByOrgId(String(id))
      rootStore.medicalKitStore.handlemedicallist(MedicalData?.data);
      setOriginalList(MedicalData?.data);
      setSortedList(MedicalData?.data);
      rootStore.loadingStore.setShowLoader(false);
    } catch (err) {
      console.log(err)
    }
  }

  const getMedicalKit = async () => {
    try {
      rootStore.loadingStore.setShowLoader(true);
      const MedicalData = await MedicalKitService.getMedicalKit();
      rootStore.medicalKitStore.handlemedicallist(MedicalData);
      setOriginalList(MedicalData);
      setSortedList(MedicalData);
      rootStore.loadingStore.setShowLoader(false);
    } catch (error) {
      console.error("Error fetching medical kits:", error);
    }
  };

  const viewmedicalkit = async (id) => {
    const apiConfig = {
      api: APIs.MedicalKit.EditKit,
      parameters: {
        "id": id
      },
      body: null
    };
  
    const res = await SafeairManager.invoke(apiConfig);
  
    if (res.data && res.data.length > 0) {
      // alert('hllo')
      // Store the relevant data in modalData state
      setModalData(res.data);  // Assuming you want to show the first item
      setModalOpen(true);  // Open the modal
    } else {
      alert("No data found!");
    }
  };

  const handleExpiryChange = async (kitId, itemId, newDate) => {
    setEditingItemId(null);
    if (!newDate) return;

    try {
      const apiConfig = {
        api: APIs.Form.updateItemExpiry,
        parameters: {
          "newDate": newDate,
          "kitId": kitId,
          "itemId": itemId
        },
        body: null,
      };

      const res = await SafeairManager.createMedical(apiConfig);
      // console.log("API Response:", res);
      if (res) {
        setModalData(prevData =>
          prevData.map(entry =>
            entry.item.id === itemId ? { ...entry, itemExpiryDate: newDate } : entry
          )
        );
      }

    } catch (error) {
      setModalOpen(false);
      let errorMessage = "Failed to update expiry date";
      if (error.response && error.response.data) {
        errorMessage = error.response.data.errorMessage;
      }
      rootStore.notificationToastStore.showNotification(errorMessage, true, 3000);

      console.error("Error:", error);
      throw error;
    }
  };


  const Modal = ({ isOpen, onClose, data }) => {
    if (!isOpen || !data || data.length === 0) return null;
  
    return (
      <div className="modal-overlay">
        <div className="modal-content">
        <img 
          src={smallclose_icon} 
          alt="Close" 
          className="close-icon" 
          onClick={onClose} 
        />
          <p>Kit Details</p>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={{ padding: "8px"}}>Name</th>
                <th style={{ padding: "8px"}}>Expiry Date</th>
              </tr>
            </thead>
            <tbody>
              {data.map((entry) => (
                <tr key={entry.id}>
                  <td style={{ padding: "12px", borderBottom: "1px solid #ddd"}}>{entry.item.name}</td>
                  
                  <td style={{ padding: "8px", borderBottom: "1px solid #ddd", textAlign:"center" }}>
                    {editingItemId === entry.id ? (
                      <input
                        style={{ padding: "5px", borderRadius: "4px", border: "1px solid #ddd" }}
                        type="date"
                        autoFocus
                        defaultValue={entry.itemExpiryDate ? format(new Date(entry.itemExpiryDate), "yyyy-MM-dd") : ""}
                        onBlur={(e) => handleExpiryChange(entry.medicalKit.id, entry.item.id, e.target.value)}
                      />
                    ) : (
                      <>
                        {entry.itemExpiryDate ? formatDate(entry.itemExpiryDate) : "Not set"}
                        <img
                          src={editsquare} // your edit icon
                          alt="Edit"
                          style={{ cursor: "pointer", marginLeft: "8px", width: "16px", height: "16px" }}
                          onClick={() => setEditingItemId(entry.id)}
                        />
                      </>
                    )}
                  </td>

                </tr>
              ))}
            </tbody>
          </table>
          {/* <button onClick={onClose} style={{ marginTop: "20px" }}>Close</button> */}
        </div>
      </div>
    );
  };

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const getPrettyTime = (date) => {
    let formattedTime = Utility.getFormatedTime(date);
    console.log("formattedTime", formattedTime);
    return formattedTime;
  };

  const getFormatedDate = (date) => {
    let localDateTime = Utility.convertUTCToLocal(date);
    let formattedDate = Utility.getFormatedDate(localDateTime);
    return formattedDate;
  };


  const sortMedicalKits = (option) => {
    const sorted = [...sortedList].sort((a, b) => {
      if (!a.timestamp) return 1; // Handle cases where timestamp is null
      if (!b.timestamp) return -1; // Handle cases where timestamp is null

      const dateA = new Date(a.timestamp);
      const dateB = new Date(b.timestamp);

      if (option === "newest") {
        return dateB - dateA; // Newest first
      } else if (option === "oldest") {
        return dateA - dateB; // Oldest first
      }
      return 0;
    });

    setSortedList(sorted);
    setFilterOption(option);
    setShowFilterOptions(false);
    setCurrentPage(1); // Reset to the first page on sort
  };

  const onSearchStrChange = (e) => {
    const value = e.target.value;
    setSearchString(value);

    if (value.trim() === "") {
      // If search string is empty, reset to original list
      setSortedList(originalList);
      setCurrentPage(1); // Reset to the first page
    }
  };

  const onSearch = () => {
    const value = searchString.trim().toLowerCase();
    if (value === "") {
      // If search string is empty, reset to original list
      setSortedList(originalList);

      setCurrentPage(1); // Reset to the first page
    } else {
      // Perform search
      const filteredKit = originalList.filter((item) => {
        return (
          (item.id && item.id.toString().toLowerCase().includes(value)) ||
          (item.totalItems && item.totalItems.toString().toLowerCase().includes(value)) ||
          (item.flight && item.flight.toString().toLowerCase().includes(value))
        );
      });

      rootStore.medicalKitStore.handlemedicallist(filteredKit);
      setSortedList(filteredKit);
      setCurrentPage(1);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      onSearch();
    }
  };

  const openQrPopup = (mKitId) => {
    setIsQrPopupOpen({ isPopupShow: true, medicalKitId: mKitId });
  };

  const closeQrPopup = () => {
    setIsQrPopupOpen({ isPopupShow: false, medicalKitId: null });
  };

  const openEditKitSidebar = (kit) => {
    setEditKit(kit);
    setIsEditSidebarOpen(true);
  };

  // const getPrettyTime = (date) => {
  //   let formattedTime = Utility.getFormatedTime(date);
  //   console.log("formattedTime",formattedTime);
  //   return formattedTime;
  // };

  // const getFormatedDate = (date) => {
  //   let localDateTime = Utility.convertUTCToLocal(date);
  //   let formattedDate = Utility.getFormatedTime(localDateTime);
  //   return formattedDate;
  // };

  const toggleEditForm = async (medicalId) => {
    try {
      const MedicalResponse = await MedicalKitService.getEditKit(medicalId);
      rootStore.medicalKitStore.handleMedicalKitId(medicalId);
      console.log("MedicalResponse++++++++++++", MedicalResponse);
      if (MedicalResponse.length > 0) {
        const finalreponse = MedicalResponse[0];
        rootStore.medicalKitStore.handleDate(finalreponse.medicalKit.expiryDate);
        rootStore.medicalKitStore.handleFlightTailNo(finalreponse.medicalKit.flight);
        rootStore.medicalKitStore.handleItem(MedicalResponse);
        MedicalResponse.map((kit) => {
          rootStore.medicalKitStore.handleKitSelectedItem({ id: kit.item.id, name: kit.item.name });
        });
      }
      openEditKitSidebar(MedicalResponse);
    } catch (error) {
      console.log(error);
    }
  };
  const handlePrint = () => {

    const svgElement = qrRef.current.querySelector('svg');
    const serializer = new XMLSerializer();
    const svgString = serializer.serializeToString(svgElement);

    // Create a new iframe for printing
    const iframe = document.createElement('iframe');
    iframe.style.position = 'absolute';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = 'none';

    document.body.appendChild(iframe);

    const iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(`
      <html>
        <head>
          <title></title>
          <style>
            @media print {
              body, html {
                margin: 0;
                padding: 0;
                display: flex;
                justify-content: center;
                align-items: center;
                height: 100vh;
                width: 100vw;
                overflow: hidden;
              }
              thead, tfoot {  
                display: none !important
              }
            }
          </style>
        </head>
        <body>
          ${svgString}
        </body>
      </html>
    `);
    iframeDocument.close();

    // Wait for the iframe to load and then print
    iframe.contentWindow.focus();
    iframe.contentWindow.print();

    // Remove the iframe after printing is complete
    iframe.addEventListener('afterprint', () => {
      document.body.removeChild(iframe);
    });

    // const svgElement = qrRef.current?.outerHTML; // Get the QRCodeSVG as a string
    // if (svgElement) {
    //   const printWindow = window.open('', '', 'width=600,height=400');
    //   printWindow.document.write(`
    //   <html>
    //     <head>
    //       <title>Print QR Code</title>
    //       <style>
    //         body {
    //           text-align: center;
    //           margin: 0;
    //           padding: 20px;
    //         }
    //         img {
    //           max-width: 100%;
    //           height: auto;
    //         }
    //       </style>
    //     </head>
    //     <body>
    //       ${svgElement} <!-- Insert the QRCode SVG -->
    //     </body>
    //   </html>
    // `);
    //   printWindow.document.close();
    //   printWindow.focus();
    //   printWindow.print();
    //   printWindow.close();
    // } else {
    //   console.error("QR Code SVG not available");
    // }
  };


  // Calculate current data for pagination
  const currentData = sortedList.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  const totalPages = Math.ceil(sortedList.length / itemsPerPage);


  const shouldShowPagination = totalPages > 1;

  
  const getPdfLink = async () => {
    try {
      const res = await MedicalKitService.pdfLink();
  
      const blob = new Blob([res.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = 'file.pdf';
      a.click();
  
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading PDF:', error);
    }
  };
  
  


  return (
    <>
      <Box className="Medical-container">
        <div className="Medical-search">
          <div className="Medical-blue">
            <div className="search">
              <CommonSearchInput
                onchange={onSearchStrChange}
                value={searchString}
                onkeydown={handleKeyDown}
              />
              <CommonButton
                title="Search"
                padding="10px 24px 10px 28px"
                color="#fff"
                bgColor="#357EFF"
                radius={10}
                border="1px solid #357EFF"
                lineheight="14px"
                ml={5}
                onclick={onSearch}
              />
            </div>
            <div className="Create-container">
            {
                roleLabel === "superadmin" &&
                <button className="CreateNewKit" onClick={() => getPdfLink()} style={{ marginRight: "5px", display: "flex", alignItems: "center", cursor:"pointer" }}>
                   Export to PDF
                  <img src={download} alt="" style={{ marginLeft: "5px", height: "16px", width: "auto" }} />
                </button>
              }
              {
                roleLabel === "superadmin" &&
                <button
                  style={{cursor:"pointer"}}
                  className="CreateNewKit"
                  onClick={() => setIsCreateSidebarOpen(true)}
                >
                  Create New Kit
                </button>
              }
              <Box className="filter-icon" ref={filterDropdownRef}>
                <img
                  src={filtericon}
                  alt="Filter"
                  onClick={() => setShowFilterOptions(!showFilterOptions)}
                />
                {showFilterOptions && (
                  <Box className="dropdown">
                    <ul className="list">
                      <li
                        onClick={() => sortMedicalKits("newest")}
                        className={filterOption === "newest" ? "active" : ""}
                      >
                        Newest
                      </li>
                      <li
                        onClick={() => sortMedicalKits("oldest")}
                        className={filterOption === "oldest" ? "active" : ""}
                      >
                        Oldest
                      </li>
                    </ul>
                  </Box>
                )}
              </Box>
            </div>
          </div>
        </div>
        <div className="over">
          <div className="table">
            <DataTable
              className="medical-datatable"
              data={currentData}
              resizeable
              columns={
                roleLabel === "superadmin" || rootStore.adminStore.getSelectedOrgName.toLowerCase() == "skali" ? (
                  [
                    {
                      property: "Medical Kit Number",
                      header: <Text style={{textAlign: "center"}}>Medical Kit Number</Text>,
                      primary: true,
                      render: (item) => <Text style={{textAlign: "center"}}>{item.id}</Text>,
                    },
                    {
                      property: "Tail Number",
                      header: <Text style={{textAlign: "center"}}>Tail Number</Text>,
                      primary: true,
                      render: (item) => <Text style={{textAlign: "center"}}>{item.flight}</Text>,
                    },
                    {
                      property: "Start Date",
                      header: <Text style={{textAlign: "center"}}>Start Date</Text>,
                      primary: true,
                      render: (item) => {
                        if (item.timestamp) {
                          return <Text style={{textAlign: "center"}}>{getFormatedDate(item.timestamp)}</Text>;
                        }
                        return <Text style={{textAlign: "center"}}>N/A</Text>; // Or an empty string if preferred
                      },
                    },
                    {
                      property: "Refurbishment Due Date",
                      header: <Text style={{textAlign: "center"}}>Refurbishment Due Date</Text>,
                      primary: true,
                      render: (item) => (
                        <Text style={{textAlign: "center"}}>{item.refurbishmentDueDate && getFormatedDate(item.refurbishmentDueDate)}</Text>
                      ),
                    },
                    // {
                    //   property: "Time",
                    //   header: <Text>Time</Text>,
                    //   primary: true,
                    //   render: (item) => (
                    //     <Text>{getPrettyTime(item.timestamp)}</Text>
                    //   ),
                    // },
                    {
                      property: "Medical Kit Type",
                      header: <Text style={{textAlign: "center"}}>Medical Kit Type</Text>,
                      primary: true,
                      render: (item) => (
                        <Text style={{textAlign: "center"}}>{item.medicalKitType}</Text>
                      ),
                    },
                    {
                      property: "QR",
                      align:"center",
                      header: <Text style={{textAlign: "center"}}>QR</Text>,
                      primary: true,
                      render: (item) => {
                        return (
                          <button
                            style={{border:"none", cursor:"pointer"}}
                            className="er"
                            onClick={() => openQrPopup(item.id)}
                          >
                            <img className="Qr" src={QR} alt="QR" />
                          </button>
                        );
                      },
                    },

                    {
                      property: "Action",
                      align:"center",
                      header: <Text style={{textAlign: "center"}}>Action</Text>,
                      primary: true,
                      render: (item) => (
                        <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                          <button
                            style={{ cursor: "pointer", background: "none", border: "1px solid #357eff", padding: "2px 3px", borderRadius: "4px" }}
                            onClick={() => viewmedicalkit(item.id)}
                          >
                            <img src={view} alt="View" style={{ height: 12, width: 17 }} />
                          </button>
                          <button
                            style={{ cursor: "pointer", cursor: "pointer", background: "none", border: "1px solid #357eff", padding: "2px 3px", borderRadius: "4px" }}
                            onClick={() => openReassignSidebar(item)} title="Reassign Medical Kit"
                          >
                            <img src={reassignIcon} alt="Reassign" style={{ height: 12, width: 17 }} />
                          </button>
                        </div>
                      ),
                    }

                    // {
                    //   property: "Action",
                    //   header: <Text textAlign="center">Action</Text>,
                    //   primary: true,
                    //   render: (item) => (
                    //     <button
                    //       className="new"
                    //       onClick={() => toggleEditForm(item.id)}
                    //     >
                    //       <img className="editsquare" src={editsquare} alt="Edit" />
                    //     </button>
                    //   ),
                    // },
                  ]
                ) : (
                  [
                    {
                      align: "center",
                      property: "Medical Kit Number",
                      header: <Text style={{textAlign: "center"}}>Medical Kit Number</Text>,
                      primary: true,
                      render: (item) => <Text style={{textAlign: "center"}}>{item.id}</Text>,
                    },
                    {
                      align: "center",
                      property: "Tail Number",
                      header: <Text style={{textAlign: "center"}}>Tail Number</Text>,
                      primary: true,
                      render: (item) => <Text style={{textAlign: "center"}}>{item.flight}</Text>,
                    },
                    {
                      align: "center",
                      property: "View",
                      header: <Text style={{textAlign: "center"}}>View</Text>,
                      primary: true,
                      render: (item) => {
                        return (
                          <button
                            style={{border:"none", cursor:"pointer"}}
                            className="er"
                            onClick={() => viewmedicalkit(item.id)} // Call the function with item.id
                          >
                            <img src={view} style={{height: 15, width: 20}} alt="View" />
                          </button>
                        );
                      },
                    }
                  ]
                )
              }
            />
          </div>
        </div>

        {
          !currentData.length && <Box className="no-result-img" style={{ marginTop: "-94px" }}>
            <img src={noResult} alt="no emergency found" />
            <p>No medical kit found.</p>
          </Box>
        }

        {shouldShowPagination && (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            totalItems={sortedList.length}
            onPageChange={handlePageChange}
          />
        )}
        {isCreateSidebarOpen && (
          <CreateKitSidebar onClose={() => { setIsCreateSidebarOpen(false); rootStore.medicalKitStore.resetItems() }} />
        )}
        {isReassignSidebarOpen && selectedKitForReassign && (
          <ReassignMedicalKitSidebar
            kitData={selectedKitForReassign}
            onClose={closeReassignSidebar}
            onReassignSuccess={getMedicalKit}
          />
        )}

        {/* {isEditSidebarOpen && editKit && (
          <EditMedicalKit
            kit={editKit}
            onClose={() => {
              setIsEditSidebarOpen(false);
              setEditKit(null);
              rootStore.medicalKitStore.resetKitSelectedItem();
              rootStore.medicalKitStore.resetMedicalKitId();
            }}
          />
        )} */}

        {isQrPopupOpen.isPopupShow && (
          <Layer>
            <div className="qr-popup">
              <span className="qr-popup-close" onClick={closeQrPopup}>
                <img src={closeCross} alt="Close" />
              </span>
              <div className="Qr-image-container" ref={qrRef}>
                <QRCodeSVG value={JSON.stringify(isQrPopupOpen.medicalKitId)} height={300} width={300} ref={contentRef} />
              </div>
              <div style={{ display: "flex", gap: "10px" }}>
                <button className="qr-download-btn" onClick={() => downloadSVG(JSON.stringify(isQrPopupOpen.medicalKitId))}><img src={QRDownload} />Download Link</button>
                {/* <button className="qr-download-btn" onClick={() => downloadSVG(JSON.stringify(isQrPopupOpen.medicalKitId))}><img src={QRDownload} />Print</button> */}
                <button className="qr-download-btn" onClick={handlePrint}>
                  <img src={QRDownload} alt="QR Download" />
                  Print
                </button>


              </div>
            </div>
          </Layer>
        )}
      </Box>

      <Modal
  isOpen={isModalOpen}
  onClose={() => setModalOpen(false)}
  data={modalData}
/>
    </>
  );
}

export default observer(MedicalKit);